export default
function calculateBlocks(breaks, paramLines, removeBreaks){
  let blocks = [],
      blockID = 0,
      offsets = [];
  blocks[0] = [];

  //Remove stanza breaks if option true
  let lines = removeBreaks ? paramLines.filter((line) => line !== "") : paramLines;

  lines.forEach((line, lineNum) => {
    const words = line.split(' ');
    let currentLine = [];

    //collection of marked words
    const markedWords = breaks[lineNum+1] ? breaks[lineNum+1] : false;

    for(let i = 0; i < words.length; i++){
      if(markedWords){
        let match = markedWords.indexOf(i+1);
        //if the word is marked
        if(match >= 0){
          currentLine.push(words[i]);

          //push words of current line to block
          blocks[blockID].push(currentLine.join(' '));

          blockID++;

          //Add offset if not last word
          if(i !== words.length-1){
            offsets[blockID] = currentLine;
          }

          //move on to next block
          blocks[blockID] = [];
          currentLine = [];

          continue
        }
      }
      currentLine.push(words[i]);
    }
    if(currentLine.length > 0)
      blocks[blockID].push(currentLine.join(' '));
  });

  return {blocks, offsets}
}



// WEBPACK FOOTER //
// ./src/helpers/calculateBlocks.js